import React from 'react'
import { Icon } from 'antd'

const Loading = () => (
  <div style={{ textAlign: 'center' }}>
    <Icon type='loading' />
  </div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js